import { registrasi, updateUser, userService } from '../../_services';
import router from '../../router/index';
import Userauth from '../../auth/js/index';
import Menu from '../../data/menu';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null };

export const authentication = {
    namespaced: true,
    state: initialState,
    getters: {

    },
    actions: {
        login({ dispatch, commit }, { email, password }) {
            
            userService.login(email, password)
                .then(
                    user => {
                        commit('loginSuccess', user);
                        Userauth.localLogin(user);
                        const user_data = JSON.parse(localStorage.getItem('user'));
                        var menus = [];
                        if (user) {
                            Menu.data.forEach(element => {
                                if (element.roles === user_data.roles) {
                                    menus.push(element);
                                }
                            });
                        }
                        localStorage.setItem('menus', JSON.stringify(menus));
                        commit('menu/setMenu', menus, { root: true });
                        if (user.roles === 'ADMIN') {
                            router.push('/dashboard/admin');
                        }else if(user.roles === 'CANDIDATE'){
                            router.push('/dashboard/candidate');
                        }


                        
                    },
                    error => {
                        console.log(error);
                        commit('loginFailure', error);
                        dispatch('alert/error', error, { root: true });
                    }
                );
        },
        registrasi({ dispatch, commit }, payload) {
            
            return registrasi(payload)
                .then(
                    res => {
                        return res;
                    },
                    error => {
                        return error;
                    }
                );
        },
        update({ dispatch, commit }, payload) {
            
            return updateUser(payload)
                .then(
                    res => {
                        return res;
                    },
                    error => {
                        return error;
                    }
                );
        },
        logout({ commit }) {
            commit('logout');
            localStorage.clear();
            router.push('/auth/login');
        },
        loginWithToken({ dispatch, commit }) {
            userService.getDataUser()
                .then(
                    data => {
                      
                        commit('loginSuccess', data);
                        Userauth.localLogin(data);
                        const user_data = JSON.parse(localStorage.getItem('user'));
                        var menus = [];
                        if (data) {
                            Menu.data.forEach(element => {
                                if (element.roles === user_data.roles) {
                                    menus.push(element);
                                }
                            });
                        }
                        localStorage.setItem('menus', JSON.stringify(menus));
                        commit('menu/setMenu', menus, { root: true });
                        if (data.roles === 'ADMIN') {
                            router.push('/dashboard/admin');
                        }else if(data.roles === 'CANDIDATE'){
                            router.push('/dashboard/candidate');
                        }
                    },
                    error => {
                        console.log(error);
                        commit('loginFailure', error);
                        dispatch('alert/error', error, { root: true });
                    }
                );
        },
    },
    mutations: {
        loginRequest(state, user) {
            state.status = { loggingIn: true };
            state.user = user;
        },
        loginSuccess(state, user) {
            state.status = { loggedIn: true };
            state.user = user;
        },
        loginFailure(state) {
            state.status = {};
            state.user = null;
        },
        logout(state) {
            state.status = {};
            state.user = null;
            localStorage.clear();
        }
    }
};